import { environment } from "src/environments/environment";
import { CurrentUser } from "../data/model/current-user";
import { ClientDetails } from "src/app/models/client-details";
import { Utils } from "../utils/utils";
import { BehaviorSubject } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ShareService {
    cfg:any;
    token: string;
    user: CurrentUser;
    linked_client_id: number;
    client_avartar:string = "";

    selectedProductSubject = new BehaviorSubject<string>(null);
  
    constructor() { 
      this.cfg = environment;
    }
  
  
    getConfig(){
      return this.cfg;
    }
  
    setToken(token: string){
      localStorage.setItem("token",token);
      // this.token = token;
    }
  
    getToken(){
      return localStorage.getItem("token");
      // return this.token;
    }

  getBusinessKey(){
    // console.log(this.getConfig().businessKey);
    return this.getConfig().businessKey;
  }
  
    setUser(user: CurrentUser){
      // console.log("current user "+JSON.stringify(user));
      localStorage.setItem("user",JSON.stringify(user));
      this.user = user;
    }
  
    getUser(){
      return JSON.parse(localStorage.getItem("user"));
      // return this.user;
    }
  
    setUserProfile(profile: ClientDetails){
      this.linked_client_id = profile.id;
  
      this.user = this.getUser();
      
      this.user.profile = profile;
  
      this.setUser(this.user);
    }
  
    getLinkedClientId(){
      return this.linked_client_id;
    }
  
    getUserProfile(){
      return this.getUser()["profile"];
    }
  
    getUserId(){
      return this.getUser()["id"];
    }

    setClientAvartar(){
      var profile = this.getUser();
      this.client_avartar = Utils.generateAvatar(profile?.client?.first_name,profile?.client?.last_name);
    }

    getClientAvartar(){
      // alert(this.client_avartar);
      if(this.client_avartar.length < 1)
        this.setClientAvartar();

        return this.client_avartar;
    }
  
    getUserRoles(){
      return (this.getUser() !== null) ? this.getUser()["roles"] : [];
    }

    getUserPermissions(){
  
      return (this.getUser() !== null) ? this.getUser()["permissions"] : [];
    }
  
    hasAnyRole(roles: string[]) {
      return this.user.roles.some((role)=> roles.includes(role) )
      // return this.user.roles.includes(role);
    }
  
    hasAnyPermission(permissions: string[]) {
      return this.user.permissions.some((permission) => permissions.includes(permission));
      // return this.user.permissions.includes(permission);
    }

    setSelectedProduct(product){
      // console.log(JSON.stringify(product));
      this.selectedProductSubject.next(product);
      localStorage.setItem("selectedProduct",JSON.stringify(product));
      // this.selected_product = product;
    }

    getSelectedProduct(){
      const storedProduct = localStorage.getItem("selectedProduct");

      return storedProduct ? JSON.parse(storedProduct) : null;
    }
}
